import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { GedService } from "../api/GedService";
import { ProjectStatusService} from "../api/ProjectStatusService";

import {
  ContractStore,
  Contract,
  ContractStatusStore,
  ContractStatus,
  AddContractStatusStore,
  Status
} from "../models/ContractTypes";

import {
  GetCodeSpStore,
  ServiceResponse,
} from "../models/ServiceTypes";

export const StoreContract = create(
  persist<ContractStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      search: async (ioId: number /*, userService:string*/) => {
        try {
          set({ isLoading: true, isFinished: false });
          const data: Array<Contract> = await GedService.getContract(
            ioId /*,userService*/
          );
          set(() => ({ isLoading: false, response: data, isFinished: true }));
        } catch (err: any) {
          const error =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({
            isLoading: false,
            response: [],
            error,
            isFinished: false,
          }));
        }
      },
    }),
    {
      name: "contract-search-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);


export const StoreContractStatus = create(
  persist<ContractStatusStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      searchStatus: async (ioId: number) => {
        try {
          set({ isLoading: true, isFinished: false });
          const data = await ProjectStatusService.getContractStatus(ioId);
          set(() => ({
            isLoading: false,
            responseStatus: data,
            isFinished: true,
          }));
        } catch (err: any) {
          const error =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({ isLoading: false, error, isFinished: false }));
        }
      },
    }),
    {
      name: "contract-status-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const StoreAddContractStatus = create(
  persist<AddContractStatusStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      addStatus: async (ioId: number, projectStatus: Status) => {
        try {
          set({ isLoading: true, isFinished: false });
          const data: ContractStatus = await ProjectStatusService.addContractStatus(ioId, projectStatus);
          set(() => ({
            isLoading: false,
            responseAddedItem: data,
            isFinished: true,
          }));
        } catch (err: any) {
          const error =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({ isLoading: false, error, isFinished: false }));
        }
      },
    }),
    {
      name: "add-contract-status-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const StoreGetCodeSp = create(
  persist<GetCodeSpStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      getCodeSp: async (service_id: number) => {
        try {
          set({ isLoading: true, isFinished: false });
          const data: ServiceResponse = await GedService.getCodeSp(service_id);
          set(() => ({
            isLoading: false,
            responseCodeSp: data,
            isFinished: true,
          }));
        } catch (err: any) {
          const errorCodeSp =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({ isLoading: false, errorCodeSp, isFinished: false }));
        }
      },
    }),
    {
      name: "search-service-spcode-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

